package music.jammers.client.shared.analytics.event

import music.jammers.client.shared.analytics.FirebaseAnalytics

interface EventTrackAnalytics {

    fun onError(throwable: Throwable)
    fun onTrackAdded(id: Long)
}

internal class EventTrackAnalyticsImpl(
    private val firebaseAnalytics: FirebaseAnalytics,
) : EventTrackAnalytics {

    override fun onError(throwable: Throwable) {
        firebaseAnalytics.logEvent("event_track_error") {
            val value = throwable.message ?: throwable.toString()
            param("reason", value.take(VALUE_LIMIT))
        }
    }

    override fun onTrackAdded(id: Long) {
        firebaseAnalytics.logEvent("event_track_added") {
            param("eventTrackId", id)
        }
    }

    private companion object {

        const val VALUE_LIMIT = 40
    }
}